export default "__VITE_ASSET__BSQVWbA___"